// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Metric = t.struct({
    allowedMetrics: t.Array,
    selectedMetrics: t.Array
}, 'Metric');

export const getDefaultState = () =>
    new Metric({
        allowedMetrics: [],
        selectedMetrics: []
    });

export default Metric;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/metric.js